/* DAWIS Studio. Progressive enhancement; Shopify forms remain the source of truth. */
(() => {
  'use strict';
  const config = window.DAWIS || {};
  const root = config.root || '/';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const status = text => { const el = $('#DwStatus'); if (el) el.textContent = text; };
  const dialogOpeners = new WeakMap();
  let cartBusy = false;
  let quickRequest;
  let searchRequest;
  const syncLock = () => document.body.classList.toggle('dw-locked', !!$('dialog[open]'));
  function openDialog(dialog, opener = document.activeElement) {
    if (!dialog || dialog.open) return;
    dialogOpeners.set(dialog, opener);
    dialog.showModal();
    syncLock();
  }
  function closeDialog(dialog) { if (dialog?.open) dialog.close(); }
  function initDialogs(scope = document) {
    $$('dialog', scope).forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('close', () => {
        syncLock();
        const opener = dialogOpeners.get(dialog);
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        $$('video', dialog).forEach(video => video.pause());
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
      });
    });
  }
  async function fetchJSON(url, options = {}) {
    const response = await fetch(url, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Das hat leider nicht geklappt. Bitte versuche es erneut.');
    return data;
  }
  const htmlDocument = html => new DOMParser().parseFromString(html, 'text/html');
  function updateCartCount(count) { $$('[data-cart-count]').forEach(el => { el.textContent = String(count); }); }
  function renderCart(html) {
    if (!html) return false;
    const doc = htmlDocument(html);
    const fresh = $('[data-cart-drawer-content]', doc);
    const drawer = $('#DwCart');
    if (!fresh || !drawer) return false;
    $('[data-cart-drawer-content]', drawer).replaceWith(fresh);
    const title = $('#DwCartTitle', doc);
    if (title) $('#DwCartTitle', drawer).innerHTML = title.innerHTML;
    updateCartCount(Number(fresh.dataset.cartItemsCount || 0));
    $('[data-cart-error]', drawer).hidden = true;
    return true;
  }
  async function refreshCart() {
    const url = new URL(root, location.origin);
    url.searchParams.set('sections', 'dw-cart-drawer');
    const sections = await fetchJSON(url);
    if (!renderCart(sections['dw-cart-drawer'])) throw new Error('Warenkorb konnte nicht geladen werden. Bitte öffne die Warenkorbseite.');
  }
  async function showCart(opener) {
    const drawer = $('#DwCart');
    if (!drawer) { location.assign(config.cart || `${root}cart`); return; }
    openDialog(drawer, opener);
    drawer.setAttribute('aria-busy', 'true');
    try { await refreshCart(); }
    catch (error) { cartError(error.message); }
    finally { drawer.removeAttribute('aria-busy'); }
  }
  function cartError(message) {
    const error = $('[data-cart-error]', $('#DwCart'));
    if (!error) return;
    error.textContent = message + ' ';
    const link = document.createElement('a');
    link.href = config.cart || `${root}cart`; link.textContent = 'Zum Warenkorb'; link.style.textDecoration = 'underline';
    error.appendChild(link); error.hidden = false;
  }
  async function changeCart(key, quantity, trigger) {
    if (cartBusy) return;
    cartBusy = true;
    const drawer = $('#DwCart');
    drawer.setAttribute('aria-busy', 'true');
    const action = trigger?.dataset.cartAdjust;
    try {
      const data = await fetchJSON((config.change || `${root}cart/change`) + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['dw-cart-drawer'], sections_url: location.pathname })
      });
      if (!renderCart(data.sections?.['dw-cart-drawer'])) await refreshCart();
      updateCartCount(data.item_count);
      status('Warenkorb aktualisiert.');
      const next = $$('[data-key]', drawer).find(el => el.dataset.key === key && (action ? el.dataset.cartAdjust === action : el.hasAttribute('data-cart-quantity')));
      (next || $('[data-close]', drawer))?.focus({ preventScroll: true });
    } catch (error) { cartError(error.message); }
    finally { cartBusy = false; drawer.removeAttribute('aria-busy'); }
  }
  async function addToCart(form) {
    if (form.dataset.busy === 'true') return;
    const button = $('[data-add-button]', form);
    if (!button || button.disabled || !form.reportValidity()) return;
    const error = $('[data-form-error]', form);
    const label = $('span', button);
    const originalLabel = label.textContent;
    form.dataset.busy = 'true'; button.disabled = true;
    button.setAttribute('aria-busy', 'true'); label.textContent = 'Wird hinzugefügt …'; error.hidden = true;
    const data = new FormData(form);
    data.set('sections', 'dw-cart-drawer'); data.set('sections_url', location.pathname);
    try {
      const result = await fetchJSON((config.add || `${root}cart/add`) + '.js', { method: 'POST', body: data });
      const originDialog = form.closest('dialog');
      const returnFocus = originDialog ? dialogOpeners.get(originDialog) : button;
      closeDialog(originDialog);
      const drawer = $('#DwCart');
      openDialog(drawer, returnFocus || button);
      if (!renderCart(result.sections?.['dw-cart-drawer'])) {
        try { await refreshCart(); }
        catch { cartError('Das Produkt wurde hinzugefügt. Die Ansicht konnte nicht aktualisiert werden.'); }
      }
      status('Produkt zum Warenkorb hinzugefügt.');
    } catch (err) {
      error.textContent = err instanceof TypeError ? 'Die Verbindung wurde unterbrochen. Bitte prüfe deinen Warenkorb, bevor du erneut bestellst.' : err.message;
      error.hidden = false;
    } finally {
      form.dataset.busy = 'false'; button.disabled = false;
      button.removeAttribute('aria-busy'); label.textContent = originalLabel;
      form.closest('[data-product-root]')?._dwProduct?.update(false);
    }
  }
  function changeGallery(gallery, mediaId) {
    if (!gallery) return;
    const items = $$('[data-media]', gallery);
    const target = items.find(item => item.dataset.media === String(mediaId));
    if (!target) return;
    items.forEach(item => {
      const active = item === target; item.hidden = !active; item.classList.toggle('is-active', active);
      if (!active) $$('video', item).forEach(video => video.pause());
    });
    $$('[data-thumb]', gallery).forEach(button => button.setAttribute('aria-pressed', String(button.dataset.thumb === String(mediaId))));
  }
  function initProducts(scope = document) {
    $$('[data-product-root]', scope).forEach(el => {
      if (el._dwProduct) return;
      const json = $('[data-product-data]', el);
      if (!json) return;
      let data;
      try { data = JSON.parse(json.textContent); } catch { return; }
      const form = $('[data-product-form]', el);
      const native = $('[data-native-variant]', el);
      const fields = $$('[data-option-index]', el);
      const priceContainer = $('[data-price-container]', el);
      const availability = $('[data-availability]', el);
      const quantity = $('input[name=quantity]', form);
      const addButton = $('[data-add-button]', form);
      const plans = $('[data-selling-plan]', form);
      const stickyButton = $('[data-sticky-button]', el);
      const api = {
        update(updateUrl = true) {
          const selected = fields.map(field => $('input:checked', field)?.value);
          const variant = fields.length ? data.variants.find(v => v.options.every((value, i) => value === selected[i])) : data.variants.find(v => v.id === Number(native.value)) || data.variants[0];
          native.value = variant ? String(variant.id) : '';
          const available = !!variant?.available;
          const busy = form.dataset.busy === 'true';
          addButton.disabled = !available || busy;
          const text = !variant ? 'Nicht verfügbar' : available ? 'In den Warenkorb' : 'Ausverkauft';
          if (!busy) $('span', addButton).textContent = text;
          if (stickyButton) { stickyButton.disabled = !available || busy; stickyButton.textContent = text; }
          fields.forEach((field, index) => {
            $('[data-option-label]', field).textContent = selected[index] || '';
            $$('input', field).forEach(input => {
              const possible = data.variants.some(v => v.available && v.options[index] === input.value && v.options.every((value, i) => i === index || value === selected[i]));
              input.closest('label').classList.toggle('is-unavailable', !possible);
              input.title = possible ? '' : 'Mit dieser Auswahl aktuell nicht verfügbar';
            });
          });
          availability.replaceChildren();
          if (available) { const dot = document.createElement('span'); dot.className = 'dw-stock-dot'; availability.appendChild(dot); }
          availability.append(document.createTextNode(!variant ? 'Diese Kombination ist nicht verfügbar' : available ? 'Verfügbar' : 'Diese Variante ist ausverkauft'));
          const price = document.createElement('div'); price.className = 'dw-price'; price.dataset.price = '';
          if (variant) {
            let displayedPrice = variant.price;
            if (plans) {
              $$('option', plans).forEach(option => { option.disabled = !!option.value && !variant.allocations.some(a => String(a.id) === option.value); });
              if (plans.selectedOptions[0]?.disabled) plans.value = [...plans.options].find(o => !o.disabled)?.value || '';
              const allocation = variant.allocations.find(a => String(a.id) === plans.value);
              if (allocation) displayedPrice = allocation.price;
            }
            const regular = document.createElement('span'); regular.textContent = displayedPrice; price.appendChild(regular);
            if (variant.compare && !plans?.value) {
              const compare = document.createElement('s'); compare.textContent = variant.compare; price.appendChild(compare);
              const sale = document.createElement('span'); sale.className = 'dw-sale'; sale.textContent = `−${variant.discount}%`; price.appendChild(sale);
            }
            if (variant.unit) { const unit = document.createElement('small'); unit.className = 'dw-unit'; unit.textContent = variant.unit; price.appendChild(unit); }
            quantity.min = variant.min; quantity.step = variant.step;
            if (variant.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
            if (Number(quantity.value) < variant.min) quantity.value = variant.min;
            if (variant.max != null && Number(quantity.value) > variant.max) quantity.value = variant.max;
            if (variant.media && updateUrl) changeGallery($('[data-gallery]', el), variant.media);
            const stickyPrice = $('[data-sticky-price]', el); if (stickyPrice) stickyPrice.textContent = displayedPrice;
          }
          priceContainer.replaceChildren(price);
          if (updateUrl && !el.hasAttribute('data-quick-product')) {
            const url = new URL(location.href);
            if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
            history.replaceState({}, '', url);
          }
        }
      };
      el._dwProduct = api;
      fields.forEach(field => field.addEventListener('change', () => api.update()));
      plans?.addEventListener('change', () => api.update(false));
      api.update(false);
      const gallery = $('[data-gallery]', el);
      if (gallery) {
        let start;
        gallery.addEventListener('touchstart', event => { start = { x: event.touches[0].clientX, y: event.touches[0].clientY }; }, { passive: true });
        gallery.addEventListener('touchend', event => {
          if (!start || !event.changedTouches[0] || event.target.closest('video,iframe,model-viewer')) return;
          const dx = event.changedTouches[0].clientX - start.x, dy = event.changedTouches[0].clientY - start.y;
          if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.5) galleryStep(gallery, dx < 0 ? 1 : -1);
          start = null;
        }, { passive: true });
      }
      const sticky = $('[data-sticky-buy]', el);
      if (sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0); }, { threshold: 0 });
        observer.observe(addButton);
        el._dwObserver = observer;
      }
    });
  }
  function galleryStep(gallery, step) {
    const items = $$('[data-media]', gallery);
    const index = items.findIndex(item => !item.hidden);
    if (items.length) changeGallery(gallery, items[(index + step + items.length) % items.length].dataset.media);
  }
  async function quickView(url, opener) {
    const dialog = $('#DwQuickView'), content = $('[data-quick-content]', dialog);
    quickRequest?.abort(); quickRequest = new AbortController();
    content.innerHTML = '<p class="dw-quick-loading" role="status">Produkt wird geladen …</p>';
    openDialog(dialog, opener);
    try {
      const endpoint = new URL(url, location.origin); endpoint.searchParams.set('section_id', 'dw-quick-view');
      const response = await fetch(endpoint, { signal: quickRequest.signal });
      if (!response.ok) throw new Error('Produkt konnte nicht geladen werden.');
      const doc = htmlDocument(await response.text()), product = $('[data-quick-product]', doc);
      if (!product) throw new Error('Produkt konnte nicht geladen werden.');
      const heading = $('h1', product);
      if (heading) { const h2 = document.createElement('h2'); h2.className = 'dw-quick-title'; h2.textContent = heading.textContent; heading.replaceWith(h2); }
      content.replaceChildren(product); initProducts(content); initDialogs(content);
    } catch (error) {
      if (error.name === 'AbortError') return;
      content.replaceChildren();
      const p = document.createElement('p'); p.className = 'dw-quick-loading';
      const link = document.createElement('a'); link.href = url; link.className = 'dw-text-link'; link.textContent = 'Produktseite öffnen →';
      p.appendChild(link); content.appendChild(p);
    }
  }
  function initTabs(scope = document) {
    $$('[data-tabs]', scope).forEach(container => {
      if (container.dataset.tabsReady) return; container.dataset.tabsReady = 'true';
      const tabs = $$('[role=tab]', container);
      const activate = tab => {
        tabs.forEach(button => { const active = button === tab; button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1; const panel = document.getElementById(button.getAttribute('aria-controls')); panel?.toggleAttribute('data-tab-hidden', !active); });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          const actions = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 };
          if (!(event.key in actions)) return; event.preventDefault();
          const next = tabs[actions[event.key]]; activate(next); next.focus();
        });
      });
    });
  }
  async function recommendations(scope = document) {
    for (const el of $$('[data-recommendations]', scope)) {
      if (el.dataset.loaded) continue; el.dataset.loaded = 'true';
      try { const res = await fetch(el.dataset.recommendations); if (!res.ok) continue; const doc = htmlDocument(await res.text()); const content = $('[data-recommendations]', doc); if (content) el.innerHTML = content.innerHTML; } catch { /* Recommendations are optional. */ }
    }
  }
  let predictiveTimer;
  async function predictiveSearch(input) {
    const term = input.value.trim(), target = $('#DwPredictive');
    searchRequest?.abort();
    if (term.length < 2) { target.replaceChildren(); input.setAttribute('aria-expanded', 'false'); return; }
    searchRequest = new AbortController();
    const url = new URL(`${root}search/suggest`, location.origin);
    url.search = new URLSearchParams({ q: term, 'resources[type]': 'product', 'resources[limit]': '5', section_id: 'dw-predictive-search' });
    try {
      const response = await fetch(url, { signal: searchRequest.signal });
      if (!response.ok) throw new Error('Search unavailable');
      const doc = htmlDocument(await response.text()); const content = $('.dw-predictive', doc);
      if (input.value.trim() !== term) return;
      target.replaceChildren(); if (content) target.appendChild(content);
      input.setAttribute('aria-expanded', String(!!content));
    } catch (error) { if (error.name !== 'AbortError') { target.textContent = 'Drücke Enter, um nach Produkten zu suchen.'; input.setAttribute('aria-expanded', 'false'); } }
  }
  function initMotion(scope = document) {
    if (!document.body.classList.contains('dw-motion') || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .08 });
    $$('[data-reveal]', scope).forEach(el => { if (el.classList.contains('dw-observe')) return; el.classList.add('dw-observe'); observer.observe(el); });
  }
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close]'); if (close) { closeDialog(close.closest('dialog')); return; }
    const opener = event.target.closest('[data-open]'); if (opener) { openDialog(document.getElementById(opener.dataset.open), opener); return; }
    const cartOpener = event.target.closest('[data-cart-open]'); if (cartOpener && !event.ctrlKey && !event.metaKey) { event.preventDefault(); showCart(cartOpener); return; }
    const quick = event.target.closest('[data-quick-view]'); if (quick) { quickView(quick.dataset.quickView, quick); return; }
    const zoom = event.target.closest('[data-zoom]'); if (zoom) { event.preventDefault(); const img = $('[data-zoom-image]'); img.src = zoom.dataset.zoom; img.alt = $('img', zoom)?.alt || 'Produktansicht'; openDialog($('#DwZoom'), zoom); return; }
    const thumb = event.target.closest('[data-thumb]'); if (thumb) { changeGallery(thumb.closest('[data-gallery]'), thumb.dataset.thumb); return; }
    const galleryButton = event.target.closest('[data-gallery-step]'); if (galleryButton) { galleryStep(galleryButton.closest('[data-gallery]'), Number(galleryButton.dataset.galleryStep)); return; }
    const quantity = event.target.closest('[data-quantity]'); if (quantity) { const input = $('input', quantity.closest('.dw-quantity')); quantity.dataset.quantity === 'plus' ? input.stepUp() : input.stepDown(); input.dispatchEvent(new Event('change', { bubbles: true })); return; }
    const cartAdjust = event.target.closest('[data-cart-adjust]');
    if (cartAdjust) {
      const input = $('input', cartAdjust.closest('.dw-quantity')); const step = Number(input.step) || 1; const min = Number(input.dataset.lineMin) || 1;
      let value = Number(input.value) + Number(cartAdjust.dataset.cartAdjust) * step;
      if (value < min) value = Number(cartAdjust.dataset.cartAdjust) < 0 ? 0 : min;
      if (input.max && value > Number(input.max)) value = Number(input.max);
      input.value = Math.max(0, value);
      if (cartAdjust.closest('#DwCart')) changeCart(cartAdjust.dataset.key, Number(input.value), cartAdjust);
      return;
    }
    const remove = event.target.closest('[data-cart-remove]'); if (remove?.closest('#DwCart')) { event.preventDefault(); changeCart(remove.dataset.cartRemove, 0, remove); }
  });
  document.addEventListener('submit', event => { const form = event.target.closest('[data-product-form]'); if (form) { event.preventDefault(); addToCart(form); } });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]') && event.target.closest('#DwCart')) { if (event.target.checkValidity()) changeCart(event.target.dataset.key, Number(event.target.value), event.target); else event.target.reportValidity(); }
    if (event.target.matches('[data-sort]')) { const url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); url.searchParams.delete('page'); location.assign(url); }
  });
  document.addEventListener('input', event => { if (event.target.matches('[data-predictive-input]')) { clearTimeout(predictiveTimer); const input = event.target; predictiveTimer = setTimeout(() => predictiveSearch(input), 220); } });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { const dialogs = $$('dialog[open]'); if (dialogs.length) { event.preventDefault(); closeDialog(dialogs[dialogs.length - 1]); } $$('.dw-nav-details[open]').forEach(el => el.removeAttribute('open')); } });
  document.addEventListener('click', event => { $$('.dw-desktop-nav .dw-nav-details[open]').forEach(el => { if (!el.contains(event.target)) el.removeAttribute('open'); }); });
  function init(scope = document) { initDialogs(scope); initProducts(scope); initTabs(scope); initMotion(scope); recommendations(scope); }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { $$('[data-product-root]', event.target).forEach(el => el._dwObserver?.disconnect()); });
  document.addEventListener('shopify:block:select', event => { const panel = event.target.closest('[role=tabpanel]'); if (panel) document.getElementById(panel.getAttribute('aria-labelledby'))?.click(); });
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart().catch(() => {}); });
  init();
})();
/* Legacy customer address forms use Shopify's country/province data. */
(() => {
  function addresses(scope=document) {
    scope.querySelectorAll('[data-address-country]').forEach(country => {
      if(country.dataset.ready) return;
      country.dataset.ready='true';
      if(country.dataset.default) country.value=country.dataset.default;
      const province=document.getElementById(country.dataset.province);
      if(!province) return;
      function populate(){
        let pairs=[];try{pairs=JSON.parse(country.selectedOptions[0]?.dataset.provinces||'[]')}catch{}
        province.replaceChildren(...pairs.map(([value,label])=>new Option(label,value)));
        province.closest('[data-province-wrap]').hidden=!pairs.length;
        province.disabled=!pairs.length;
        if(province.dataset.default) province.value=province.dataset.default;
      }
      country.addEventListener('change',populate);populate();
    });
    scope.querySelectorAll('.dw-default-address').forEach(wrap=>{const input=wrap.querySelector('input'),label=wrap.querySelector('label');if(input&&label)label.htmlFor=input.id});
  }
  addresses();document.addEventListener('shopify:section:load',event=>addresses(event.target));
  const recover=document.getElementById('Recover');
  const openRecover=()=>{if(recover&&location.hash==='#Recover')recover.open=true};
  openRecover();window.addEventListener('hashchange',openRecover);
})();
